import { collection, doc, limit, onSnapshot, orderBy, query, serverTimestamp, updateDoc, writeBatch, getDocs, where } from 'firebase/firestore';
import { db } from '../firebase';

export function subscribeNotifications(uid, cb) {
    if (!uid) return () => {};
    const q = query(collection(db, 'users', uid, 'notifications'), orderBy('createdAt', 'desc'), limit(50));
    return onSnapshot(q, (snap) => {
        cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
}

export async function markNotificationRead(uid, notificationId) {
    if (!uid || !notificationId) return;
    try {
        const ref = doc(db, 'users', uid, 'notifications', notificationId);
        await updateDoc(ref, { isRead: true, readAt: serverTimestamp() });
    } catch (err) {
        console.error('markNotificationRead failed', err);
    }
}

// P2-DATA-4: Paginate through all unread notifications instead of only marking 50
export async function markAllNotificationsRead(uid) {
    if (!uid) return;
    const BATCH_SIZE = 450;
    let hasMore = true;

    while (hasMore) {
        const q = query(
            collection(db, 'users', uid, 'notifications'),
            where('isRead', '==', false),
            limit(BATCH_SIZE)
        );
        const snap = await getDocs(q);
        if (snap.empty) {
            hasMore = false;
            break;
        }
        const batch = writeBatch(db);
        snap.docs.forEach((d) => {
            batch.update(d.ref, { isRead: true, readAt: serverTimestamp() });
        });
        await batch.commit();
        hasMore = snap.size === BATCH_SIZE;
    }
}
